import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VideoComponent} from './video.component';
import {TranslocoModule} from '@ngneat/transloco';
import {IconsModule} from '@paperlessio/sdk/icons';

@NgModule({
  declarations: [
    VideoComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    IconsModule
  ],
  exports: [
    VideoComponent
  ]
})
export class VideoModule {
  constructor() { }
}
